export default __webpack_public_path__ + "static/media/My_car_website_images-12_17.1aaeb787.webp";